"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Stargate Internal
 * Invitae API for internal apps
 *
 * The version of the OpenAPI document: 9.4.4
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProbandConditionResponseNameEnum = void 0;
exports.ProbandConditionResponseNameEnum = {
    BreastCancer: 'Breast cancer',
    EndometrialUterineCancer: 'Endometrial/uterine cancer',
    OvarianFallopianTubePrimaryPeritonealCancer: 'Ovarian/Fallopian tube/primary peritoneal cancer',
    ProstateCancer: 'Prostate cancer',
    PancreaticCancer: 'Pancreatic cancer',
    ColonRectalCancer: 'Colon/rectal cancer',
    ColonRectalPolyps: 'Colon/rectal polyps',
    OtherCancer: 'Other cancer',
    LynchSyndromeRiskModelScore: 'Lynch Syndrome risk model score'
};
